import space from '@styled-system/space'
import typography from '@styled-system/typography'
import { em } from 'polished'
import styled, { css } from 'styled-components'

import FirstBlockWrapper from 'components/_special/FirstBlockWrapper'
import DynamicImage from 'components/DynamicImage'
import List from 'components/List'
import CostContainerSale from 'containers/CostContainerSale'
import { Col, Row } from 'styles/components/layout'

export const FirstBlockWrapperStyled = styled(FirstBlockWrapper)`
  color: ${p => p.theme.colors.white};
  background-color: ${p => p.theme.colors[p.bg || 'purpleHeart']};
  padding-bottom: ${p => em(p.isExtraBottomIndent ? 40 : 20)};

  ${p => p.theme.mq.upMd} {
    padding-bottom: ${em(40)};
  }
`

export const Header = styled.div`
  margin: 0 auto ${em(10)};
  max-width: ${em(644)};
  text-align: center;
`

export const SalesContainer = styled.div`
  max-width: ${em(450)};
  margin: 0 auto;

  ${p => p.theme.mq.upMd} {
    margin: 0;
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  width: ${em(420)};
  max-width: 90%;
  margin: 0 auto;
  padding-top: ${em(20)};

  ${p => p.theme.mq.upMd} {
    position: absolute;
    width: ${em(406)};
    max-width: none;
    background-position: 0 0;
    height: ${em(310)};
    right: 5%;
    padding-top: ${em(0)};
  }

  ${p => p.theme.mq.upLg} {
    position: relative;
    right: auto;
    max-width: 100%;
    padding-top: ${em(25)};
    width: ${em(530)};
    height: ${em(310)};
  }
`

export const DiscountLabelRound = styled.div`
  position: absolute;
  top: 0;
  right: -2%;
  width: ${em(60)};
  height: ${em(60)};
  border-radius: 50%;
  background: ${p => p.theme.colors[p.bg || 'yellow']};
  color: ${p => p.theme.colors[p.textColor || 'black']};
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: center;
  transform: rotateZ(15deg);

  ${p => p.theme.mq.upMd} {
    top: -3%;
    right: -3%;
  }

  ${p => p.theme.mq.upLg} {
    width: ${em(104)};
    height: ${em(104)};
    right: initial;
    left: -4%;
    top: -6%;
  }
`

export const LabelValue = styled.span`
  font-size: ${em(16)};
  line-height: ${em(21, 16)};
  text-align: center;

  ${p => p.theme.mq.upLg} {
    font-size: ${em(27)};
    line-height: ${em(35, 27)};
  }

  ${({ isPrefix }) =>
    isPrefix &&
    css`
      margin-top: -${em(5, 16)};

      ${p => p.theme.mq.upMd} {
        margin-top: -${em(10, 27)};
      }
    `}
`

export const DynamicImageStyled = styled(DynamicImage)`
  ${p => p.theme.mq.upMd} {
    height: inherit;
    object-position: left top;
  }
`

export const ListWrapper = styled.div`
  display: inline-block;
  max-width: ${em(450)};
  width: 100%;

  ${p => p.theme.mq.upLg} {
    max-width: ${em(515)};
  }
`

export const ListStyled = styled(List)`
  text-align: left;
  margin-left: 0;

  & mark {
    background: transparent;
    color: ${p => p.theme.colors[p.markColor || 'grass']};
  }
`

export const RowStyled = styled(Row)`
  padding-top: ${em(20)};

  ${p => p.theme.mq.upMd} {
    padding-top: ${em(40)};
  }
`

export const ColStyled = styled(Col)`
  position: relative;
  ${space};
  ${typography};
`

export const LabelsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${em(30)};

  ${p => p.theme.mq.upMd} {
    margin-bottom: ${em(40)};
  }
`

export const DiscountLabel = styled.div`
  background: ${p => p.theme.colors[p.bg || 'yellow']};
  color: ${p => p.theme.colors[p.textColor || 'black']};
  font-family: ${p => p.theme.typography.mediumFont};
  padding: ${em(4)} ${em(5)} ${em(7)};
  border-radius: ${em(4)};

  ${p => p.theme.mq.upMd} {
    padding: ${em(5)} ${em(5)} ${em(7)};
  }
`

export const DiscountNameLabel = styled.div`
  background: ${p => p.theme.colors.lighterGrayOp3};
  padding: ${em(4)} ${em(11)} ${em(7)};
  border-radius: ${em(4)};
  margin-left: ${em(10)};

  ${p => p.theme.mq.upMd} {
    padding: ${em(5)} ${em(11)} ${em(7)};
  }
`

export const LabelText = styled.div`
  font-size: ${p => p.theme.typography.textDisclaimer};
  font-weight: 400;
  line-height: 1;

  ${p => p.theme.mq.upMd} {
    font-size: ${p => p.theme.typography.textDisclaimerMd};
  }
`

export const CostWrapper = styled.div`
  display: flex;
  justify-content: ${p => (p.isMobileLeftAlign ? 'flex-start' : 'center')};
  align-items: center;

  ${p => p.theme.mq.upMd} {
    justify-content: start;
  }
`

export const CostContainerSaleStyled = styled(CostContainerSale)`
  margin-right: ${em(30)};
`

export const ButtonInner = styled.span`
  display: inline-block;
  // font-family: ${p => p.theme.typography.mediumFont};
  font-weight: 400;
  font-size: ${p => p.theme.typography.fontSize};
  line-height: 2;
  padding: ${em(2)} ${em(25)} ${em(6)};

  ${p => p.theme.mq.upMd} {
    font-size: ${p => p.theme.typography.fontSize};
    line-height: 1.77;
  }
`

export const Decorations = styled.div`
  position: absolute;
  top: -${em(10)};
  right: 0;
  left: 0;
  margin: 0 auto;
  width: 80%;
  max-width: ${em(400)};

  ${p => p.theme.mq.upMd} {
    top: -${em(30)};
    right: 10%;
    left: initial;
    margin: 0;
    width: ${em(266)};
    max-width: none;
  }

  ${p => p.theme.mq.upLg} {
    right: -5%;
    top: -20%;
    width: 67%;
  }

  ${p => p.theme.mq.upXl} {
    top: -${em(70)};
    right: -${em(20)};
    max-width: ${em(393)};
  }
`
